export const sidebar_base = (data) => ({ type: 'COLLAPSE', data });